import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { MetricCard } from 'components/ui/MetricCard/MetricCard'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { KpiBand } from './HrKpiBand.styled'

export const HrKpiBand = () => {
  const { attendanceSummary, openHRRequestCount } = useSelector(
    (state: RootState) => state.hrDashboard,
  )

  const a = attendanceSummary
  const total = a
    ? a.present + a.absent + a.leave + a.excused + a.holidayIn + a.holidayOut + a.sickLeave + a.offDay + a.training + a.vacation + a.maternityLeave + a.unassigned
    : 280
  const present = a?.present ?? 231
  const onLeave = a ? a.leave + a.vacation + a.sickLeave + a.maternityLeave : 23
  const presentPct = total > 0 ? Math.round((present / total) * 100) : 0
  const openRequests = openHRRequestCount ?? 0

  return (
    <KpiBand>
      <MetricCard label='Total staff' value={String(total)} />
      <MetricCard label='Present today' value={String(present)} trailing={<StatusPill status='success'>{presentPct}%</StatusPill>} />
      <MetricCard label='On leave' value={String(onLeave)} trailing={<StatusPill status='warning'>leave</StatusPill>} />
      <MetricCard
        label='Open requests'
        value={String(openRequests)}
        trailing={openRequests > 0 ? <StatusPill status='info'>pending</StatusPill> : undefined}
      />
    </KpiBand>
  )
}
